import { IExecutionOptions } from '../models/query';
import { ConditionalHelper } from '../helpers/ConditionalHelper';
import { IQueryOptionsCourses } from '../models/query/options';
import { BaseCollectionQuery } from './BaseCollectionQuery';
import { ICourse } from '../models/learning';
import { Query } from './Query';

export class CoursesQuery extends BaseCollectionQuery<IQueryOptionsCourses> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsCourses {
		const { code, codeQuery, key, keyQuery, collectionItemConditional, sort, options = {} } = this.queryOptions;
		return {
			code,
			codeQuery,
			key,
			keyQuery,
			collectionItemConditional,
			sort,
			...(options.courses || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { sort } = this.options;

		let courses = this.getCourses(executionOptions) as any;
		if (sort) {
			courses = this.applySort(courses, sort, undefined, executionOptions.inputs);
		}
		return courses && courses.map(course => this.getCourseResult(executionOptions, course));
	}
	getCourses(executionOptions: IExecutionOptions): ICourse[] {
		const conditionalHelper = new ConditionalHelper({ conditions: [] }, this.translationHelper);
		const {
			code,
			collectionItemConditional = { conditions: [] },
		} = this.options;
		if (code && !collectionItemConditional.conditions.find(condition => condition.field === 'code')) {
			collectionItemConditional.conditions.push({
				field: 'code',
				operator: '=',
				value: code,
			});
		}
		const context = Query.getContext(executionOptions, this.queryOptions);
		const collectionItems = context.courses
			.filter(item => conditionalHelper.matches(item, collectionItemConditional, executionOptions));
		return collectionItems;
	}
	getCourseResult<T>(executionOptions: IExecutionOptions, course: ICourse): T {
		const { key } = this.options;
		return this.getCourseValue(executionOptions, course, key) as any;
	}
	getCourseValue<T>(executionOptions: IExecutionOptions, course: ICourse, key: string = null): T {
		if (course) {
			if (key) {
				return course[key];
			}
			return course as any;
		}
		return;
	}
}